import { Map } from 'immutable';
import {
  REQUEST_STARTED,
  REQUEST_FINISHED,
  REQUEST_FAILURE,
  CLEAR_SERVER_ERRORS,
  MODAL_OPEN,
  MODAL_CLOSE,
  REQUEST_SUCCESS,
  CLEAR_SERVER_SUCCESS
} from './app.actionTypes';

const initialState = Map().merge({
  loading: 0,
  serverErrors: null,
  statusError: null,
  serversuccess : null,
  modal : {
    open : false,
    description :""
  }
});

const appReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUEST_STARTED:
      return state.merge({
        loading: state.get('loading') + 1
      });
    case REQUEST_FINISHED:
      return state.merge({
        loading: state.get('loading') - 1
      });
    case REQUEST_FAILURE:
      return state.merge({
        loading: 0,
        serverErrors: payload.serverErrors,
        statusError: payload.statusError
      });
    case CLEAR_SERVER_ERRORS:
      return state.merge({
        serverErrors: null
      });

    case REQUEST_SUCCESS:
      return state.merge({
        serversuccess : true,
        modal : {
          open : false,
          description : ""
        },
      });

    case CLEAR_SERVER_SUCCESS:
      return state.merge({
        serversuccess : false
      });

    case MODAL_OPEN:
      return state.merge({
        modal : {
          open : true,
          description : payload
        },

      })

    case MODAL_CLOSE:
      return state.merge({
        modal : {
          open : false,
          description : ""
        },
      })

    default:
      return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/state/app/app.reducers.js